import { useEffect, useRef, useState } from 'react';
import { PrimaryButton } from './Button';
import QrScanner from 'qr-scanner';
function Scanner({ onScan, }) {

  const containerRef = useRef(null);
  const videoRef = useRef(null);
  let scanner = undefined;

  const [result, setResult] = useState('');
  const [message, setMessage] = useState('');
  const [manualInput, setManualInput] = useState('');

  const setQrResult = (qrResult) => {
    if (!qrResult || !qrResult.data) {
      console.log('No QR code found. Please try again.');
      return;
    }
    console.log(qrResult.data);
    setResult(qrResult.data);
    setMessage('Code scanned successfully');

    onScan(qrResult.data); // Call the onScan prop with the result
    scanner.stop(); // Stop scanning after a successful scan
  }

  const init = async () => {
    try {
      console.log('Initializing scanner');
      //throw new Error('Scanner initialization not supported in this environment'); // Uncomment this line to simulate an error
      setResult('');
      const video = videoRef.current;
      scanner = new QrScanner(video, qrResult => setQrResult(qrResult), {
        onDecodeError: error => {
        },
        highlightScanRegion: true,
        highlightCodeOutline: true,
      });

      await scanner.start()

    } catch (error) {
      console.error('Error initializing scanner:', error);
      setMessage('Error initializing scanner: ' + error.message);
    }
  };


  useEffect(() => {
    init();
    return () => {
      console.log('Cleaning up scanner');
      scanner?.stop(); // Stop the scanner when the component unmounts
    };
  }, []);

  const containerStyle = `${(result || message) ? 'hidden' : ''} example-style-2`;

  return (
    <div>
      <div id="video-container" class={containerStyle} ref={containerRef}>
        <video id="qr-video" ref={videoRef}></video>
      </div>
      {message}
      <div>
      <input placeholder='Enter manual request message' onChange={(e)=>setManualInput(e.target.value)}></input>
      <button onClick={() => onScan(manualInput)}>Submit</button>
      </div>
      <PrimaryButton onClick={() => onScan('5mypGao4p2ponmiR87fXsXe3JJ3phtxBD0Df+C87hyE0abFXfchm3H/LtVkNP3aNR06XFLdvJjPwEOTjafsnCoUW3WUG6bzGKzoSrVKgCOrc80imtXSeD1Bwq+zcaVqFtZJh92/awiX65mttBf4MhP6YrusVNZlhwH7yPpI0uow=')} >Sample Register</PrimaryButton>
      <PrimaryButton onClick={() => onScan('CPBWJcgwIPTlNSDJNseLH+EWg9S4g1Z9r8DtBO1XWo2UplhNf1e6JNnmmj/PuD6RvgiGyc6YhwVIxqrzW9ftoLLxLjo/E4ePVQ9spOfPwDPZwUoMnAQbdk1TPd7mkd+2VvlwPiLug4vj01raQSfSUTFVqJC2hc9L/xx5ckHqGDg=')} >Sample Renew</PrimaryButton>
      <PrimaryButton onClick={() => onScan('1TZO/t+5yfpioa2amr7lLJBWv+HCw4kuYTAe83+3DWh5DbiFD8yNl0kHrk/B4y8R5emaNG1v/C6SLR3REsIRjUgZ8xsIJQjiA5pow7diYzQ0cWMri++ebJhzyyjLKvmrpztMa1/6MrNDfcLJALvAyHnKnPBlQIz/3yo3axS4HWM=')} >Sample Revoke</PrimaryButton>
    </div>
  );
}

export default Scanner;